import { RootState } from "../../store";

export const getUserHalls = (state: RootState) => state.getHalls;
